import { Layout } from '@/components/ui/layout';
import { PrivateAdminRoute } from '@/components/organisms/route/admin';
import { ConversationsSection } from '@/pages/chatKnowledge/conversations/index';

export default function ChatPage() {
  return (
    <PrivateAdminRoute>
      <Layout title="Conversas">
        <ConversationsSection />
      </Layout>
    </PrivateAdminRoute>
  );
}
